<template>
  <div>
    <sidebar-item
      :link="{
            name: $t('sidebar.dashboard'),
            icon: 'tim-icons icon-chart-pie-36',
            path: {name: 'risk_manager.dashboard'}
          }"
    />
    <sidebar-item
      :material=true
      :link="{
            name: $t('sidebar.users'),
            icon: 'group',
            path: {name: 'risk_manager.user'}
          }"
    />
  </div>
</template>

<script>
    export default {
        name: "sidebar"
    }
</script>

<style scoped>

</style>
